import styled from "styled-components";

const ProjectList = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`;

export default ProjectList;
